import { observer } from 'mobx-react-lite'
import { Select } from 'blaze-ui/Select/Select'
import { Item } from '@react-stately/collections'
import { WixMember } from 'api/clients/BlogMetadataRecordsClient'

type WixAuthorSelectProps = {
  members: WixMember[]
  selectedAuthorId?: string
  onAuthorSelect: (authorId: string) => void
  placeholder?: string
  disabled?: boolean
}

export const WixAuthorSelect = observer(
  ({
    members,
    selectedAuthorId,
    onAuthorSelect,
    placeholder = 'Select a writer',
    disabled = false,
  }: WixAuthorSelectProps) => {
    const isEmpty = members.length === 0

    return (
      <Select
        placeholder={isEmpty ? 'No writers available' : placeholder}
        selectedKey={selectedAuthorId}
        onSelectionChange={(key) => onAuthorSelect(key as string)}
        isDisabled={isEmpty || disabled}
        useButtonWidth={true}
        useFullWidth={true}
        variant="secondary"
        size="lg"
      >
        {members.map((member) => (
          <Item key={member.id} textValue={member.name}>
            {member.name}
          </Item>
        ))}
      </Select>
    )
  },
)
